import { Select, MenuItem, SelectProps } from "@mui/material";

interface SelectFieldProps extends Omit<SelectProps, "value" | "onChange"> {
  value: string | null;
  onChange: (value: string) => void;
  options: { label: string; value: string; group?: string }[];
  disabled: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
  value,
  onChange,
  options = [],
  disabled,
  ...props
}) => {
  return (
    <Select
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      {...props}
    >
      {options.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectField;
